<template lang="html">
  <div>
    <vs-tabs v-if="activeContracts.length > 1">
      <vs-tab
        :label="`Contract ${contract.id}`"
        v-for="contract in activeContracts"
        v-bind:key="contract.id"
      >
        <usage-component :id="contract.id" />
      </vs-tab>
    </vs-tabs>
    <usage-component
      :id="activeContracts[0].id"
      v-if="activeContracts.length == 1"
    />
  </div>
</template>

<script>
import UsageComponent from "./UsageComponent.vue";
import { mapState } from "vuex";

export default {
  components: {
    UsageComponent
  },
  data() {
    return { chooser: false };
  },
  methods: {},
  computed: {
    ...mapState(["customerStatus", "contracts"]),
    ready() {
      return this.customerStatus != null && this.contracts != null;
    },
    activeContracts() {
      let activeContracts = [];
      if (this.ready) {
        activeContracts = this.contracts.filter(c => c.active);
        if (activeContracts.length == 0) {
          activeContracts = this.contracts;
        }
      }

      return activeContracts;
    }
  }
};
</script>

<style></style>
